import hashing from '~/reducers/complex/hashing';
import validators from '~/reducers/complex/validators';

export default [validators, hashing];
